import { i18nKey } from "@shared";
/**
 * The changes from `original` to the name and avatar (a data URL, or undefined for none) the user
 * left it with. Only what differs is sent; nothing at all means nothing to save.
 */
export function webhookChanges(original, name, avatarUrl) {
    const nameChanged = name !== original.name;
    const avatarChanged = avatarUrl !== original.avatarUrl;
    if (!nameChanged && !avatarChanged)
        return undefined;
    return {
        name: nameChanged ? name : undefined,
        avatar: !avatarChanged
            ? undefined
            : avatarUrl === undefined
                ? "set_to_none"
                : { value: avatarUrl },
    };
}
/** The message for a webhook register, update or regenerate that failed. */
export function webhookFailure(what) {
    switch (what) {
        case "register":
            return i18nKey("webhook.registerFailed");
        case "update":
            return i18nKey("webhook.updateFailed");
        case "regenerate":
            return i18nKey("webhook.regenerateFailed");
        default:
            return what;
    }
}
